export function imageAltTextParser(imagePath) {
    const imageName = imagePath.split("/").reverse()[0];
    return imageName.split(".")[0].split("_").join(" ");
}